<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="String(size)"
    :height="String(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="yn-svg-icon yn-svg-icon-package"
  >
    <path d="M16.5 9.4L7.5 4.21" /><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [String, Number], default: '16' },
  strokeWidth: { type: [String, Number], default: 2 },
})
</script>
